_parseNotificationMessageMarkdown